
export const copyToClipboard = async (text) => {
  let hasError = false
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
    } catch (err) {
      hasError = true
      console.log(err)
    }
  } else {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.top = '-9999px'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      const successful = document.execCommand('copy')
      const message = successful ? text : ''
      console.log(message)
    } catch (err) {
      console.error()
      hasError = true
    }
    document.body.removeChild(textArea)
  }
  return hasError
}
